import { createEntityAdapter } from '@reduxjs/toolkit';

import { type IMediaItem } from '@wix/social-groups-serverless/dist/media/types';

export const mediaItemsAdapter = createEntityAdapter<IMediaItem>({
  selectId: (item) => item.itemId,
});

export const selectors = mediaItemsAdapter.getSelectors();
